/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, func } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';

import { getUserJobs as getUserJobsAction } from 'actions/job';

import p from 'polyglot/polyglot';

import SpinnerIcon from 'components/SpinnerIcon/SpinnerIcon';
import Button from 'components/Button/Button';
import JobCard from 'components/JobCard/JobCard';
import JobCreate from 'components/JobCreate/JobCreate';
import Title from 'components/Title/Title';
import styles from './job-list.scss';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
/**
 * This is the JobList component class.
 *
 * @author Chris Andersson <chris@wbisbi.com
 * @author Niklas Rosdahl <niklas.rosdahl@vntrs.com
 */
export class JobList extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    jobs: object.isRequired,
    getUserJobs: func.isRequired,
  };

  state = {
    hasCreateModal: false,
  };

  componentDidMount() {
    const {
      auth: { token },
      getUserJobs,
    } = this.props;

    getUserJobs(token);
  }

  onOpenCreateJob = () => this.setState({ hasCreateModal: true });

  onCloseCreateJob = () => this.setState({ hasCreateModal: false });

  render() {
    const { hasCreateModal } = this.state;

    const {
      jobs: { loading, items = [] },
    } = this.props;

    const filteredJobs = items.reduce(
      // T = Truthy object F = Falsy object
      ([T, F], item) => {
        if (
          moment(item?.date_end, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day')
        ) {
          const { jobs, ...rest } = T;
          return [{ ...rest, jobs: [...jobs, item] }, F];
        }
        const { jobs, ...rest } = F;
        return [T, { ...rest, jobs: [...jobs, item] }];
      },
      [
        {
          title: 'Ongoing jobs',
          empty: 'No ongoing jobs',
          jobs: [],
          className: styles.ongoingJobs,
        },
        {
          title: 'Past jobs',
          empty: 'No past jobs',
          jobs: [],
          className: styles.pastJobs,
        },
      ]
    );

    return (
      <>
        <section className={styles.wrapper}>
          <header className={styles.header}>
            <Title title={p.t('jobs.title')} />

            <Button
              dark
              ghost
              small
              className={styles.cta}
              onClick={this.onOpenCreateJob}
            >
              NEW JOB
            </Button>
          </header>

          {filteredJobs.map(({ jobs, title, empty, className }) => (
            <div key={title}>
              <p className={styles.subtitle}>{title}</p>
              <div
                className={classNames(styles.list, {
                  [styles.center]: loading || isEmpty(jobs),
                })}
              >
                {loading ? (
                  <SpinnerIcon small />
                ) : !isEmpty(jobs) ? (
                  jobs.map(job => (
                    <JobCard key={job.job_id} className={className} {...job} />
                  ))
                ) : (
                  <p>{empty}</p>
                )}
              </div>
            </div>
          ))}
        </section>

        {hasCreateModal && <JobCreate onClose={this.onCloseCreateJob} />}
      </>
    );
  }
}

export default connect(({ auth, jobs }) => ({ auth, jobs }), {
  getUserJobs: getUserJobsAction,
})(JobList);
